var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.wrapper},[_c('div',{staticClass:"underground-token-background",class:_vm.style + ' ' + _vm.border}),_vm._v(" "),_c('div',{class:_vm.style + ' ' + _vm.tokenClass}),_vm._v(" "),_c('div',{class:_vm.shelter})])}
var staticRenderFns = []

export { render, staticRenderFns }